module.exports = __webpack_public_path__ + "static/media/auction-contract-demo-t1.f58b1123.nom";